module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-3-Australia-Landing-Page-w540.0677d008.webp";